import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CookieService } from 'ngx-cookie';


@Component({
  selector: 'ngx-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss'],
})
export class ChannelComponent implements OnInit {

  id = this.actRoute.snapshot.params['id'];

  Channels: any = [];
  idUser = '';
  showErrorMessage = false;
  errorMessage = '';
  logged = false;
  permission = '';

  searchText: any;
  email: any;

  constructor(
    public actRoute: ActivatedRoute,
    public auth: AuthService,
    public router: Router,
    public cookieService: CookieService,
  ) { }

  ngOnInit(): void {
    this.idUser = this.cookieService.get('id');
    this.loadChannels().then();
  }

  loadChannels() {
    return this.auth.listChannel(this.idUser).then(
      (data) => {
        for (const i of data) {
          this.Channels.push(i);
        }
      },
      (error) => {
        console.error('Errore', error);
        this.showErrorMessage = true;
        this.errorMessage = 'Errore API listChannel';
      },
    );
  }

  openChannel(channel_id) {
    this.router.navigate(['pages/thread-list/' + channel_id]).then();
  }

  openFavoriteThread() {
    this.router.navigate(['pages/favorite-thread-list/']).then();
  }

  openCategory() {
    this.router.navigate(['pages/category-list/']).then();
  }

  openHelpDesk() {
    this.router.navigate(['pages/helpdesk/']).then();
  }

}
